export default "__VITE_PUBLIC_ASSET__fe30d7e5__"